import { render } from "./Appel.vue?vue&type=template&id=ae5aa772"
const script = {}

import exportComponent from "C:\\Users\\pc\\Documents\\projets\\school_app_front_novation\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__